module.exports = __webpack_public_path__ + "files/5ca8394d0af1f61d5454951b86992fb9.png";